var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-2"},[(_vm.isLoaded)?_c('div',[_c('quiz-in-progress',{attrs:{"quiz-id":_vm.quizId,"is-small":false}})],1):_c('div',[_c('b-loading',{attrs:{"active":true,"is-full-page":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }